// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { X, Save } from "lucide-react";
// import "../../css/properties/propertyform.css";

// export default function PropertyForm({ property, onSubmit, onCancel, isLoading }) {
//   const [formData, setFormData] = useState(
//     property || {
//       propertyName: "",
//       propertyType: "apartment",
//       listingType: "sale",
//       location: "",
//       price: "",
//       bedrooms: "",
//       washrooms: "",
//       area: "",
//       areaunit:"",
//       status: "available",
//       description: "",
//       amenities: [],
//       images: [],
//       ownerName: "",
//       ownerContactNnumber: "",
//       propertyOtherReason:""
//     }
//   );

//   const [amenityInput, setAmenityInput] = useState("");
//   const [imageInput, setImageInput] = useState("");


// // const handleSubmit = (e) => {
// //   e.preventDefault();

// //   const data = new FormData();

// //   // Existing images (strings)
// //   formData.images
// //     .filter(img => typeof img === "string")
// //     .forEach(img => data.append("images", img));

// //   // New images (File objects)
// //   formData.images
// //     .filter(img => img instanceof File)
// //     .forEach(file => data.append("images", file));

// //   // Append other fields
// //   Object.keys(formData).forEach(key => {
// //     if (key !== "images") {
// //       if (Array.isArray(formData[key])) {
// //         data.append(key, JSON.stringify(formData[key]));
// //       } else {
// //         data.append(key, formData[key]);
// //       }
// //     }
// //   });

// //   onSubmit(data);
// // };


// const handleSubmit = (e) => {
//   e.preventDefault();

//   if (!formData.propertyName.trim()) {
//     alert("Property Name is required");
//     return;
//   }

//   if (formData.status === "other" && !formData.propertyOtherReason.trim()) {
//     alert("Please specify the reason for Other status");
//     return;
//   }

//   onSubmit(formData);
// };





//   const addAmenity = () => {
//     if (!amenityInput.trim()) return;
//     setFormData({
//       ...formData,
//       amenities: [...formData.amenities, amenityInput]
//     });
//     setAmenityInput("");
//   };

//   const removeAmenity = (index) => {
//     setFormData({
//       ...formData,
//       amenities: formData.amenities.filter((_, i) => i !== index)
//     });
//   };

//   const addImage = () => {
//     if (!imageInput.trim()) return;
//     setFormData({
//       ...formData,
//       images: [...formData.images, imageInput]
//     });
//     setImageInput("");
//   };

//  const removeImage = (index) => {
//   setFormData({
//     ...formData,
//     images: formData.images.filter((_, i) => i !== index)
//   });
// };

// useEffect(() => {
//   if (property) {
//     setFormData({
//       propertyName: property.propertyName || "",
//       propertyType: property.propertyType || "apartment",
//       listingType: property.listingType || "sale",
//       location: property.location || "",
//       price: property.price || "",
//       bedrooms: property.bedrooms || "",
//       washrooms: property.washrooms || "",
//       area: property.area || "",
//       areaunit:property.areaunit || "",
//       status: property.status || "available",
//       description: property.description || "",
//       amenities: property.amenities || [],
//       images: property.images || [],
//       ownerName: property.ownerName || "",
//       ownerContactNumber: property.ownerContactNumber || "",
//       propertyOtherReason:property.propertyOtherReason || ""
//     });
//   }
// }, [property]);


//   return (
//     <motion.div
//       className="property-form-overlay"
//       initial={{ opacity: 0, y: -20 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -20 }}
//     >
//       <div className="property-form-card">
//         {/* HEADER */}
//         <div className="form-header">
//           <h2>{property ? "Edit Property" : "Add New Property"}</h2>
//           <button className="icon-btn" onClick={onCancel}>
//             <X size={18} />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit}>
//           {/* BASIC INFO */}
//           <div className="form-group">
//             <label>Property Name *</label>
//             <input
//               required
//               value={formData.propertyName}
//               onChange={(e) =>
//                 setFormData({ ...formData, propertyName: e.target.value })
//               }
//             />
//           </div>

//           <div className="grid-2">
//             <div className="form-group">
//               <label>Property Type</label>
//               <select
//                 value={formData.propertyType}
//                 onChange={(e) =>
//                   setFormData({ ...formData, propertyType: e.target.value })
//                 }
//               >
//               <option value="apartment">Apartment/Flat</option>
//                   <option value="villa">Villa</option>
//                   <option value="residential_plot">Residential Plot/Land</option>
//                   <option value="independent_house">Independent House</option>
//                   <option value="studio_apartment">Studio Apartment</option>
//                   <option value="penthouse">Penthouse</option>
//                   <option value="builder_floor">Builder Floor</option>
//                   <option value="office_space">Office Space</option>
//                   <option value="commercial_shop">Commercial Shop</option>
//                   <option value="showroom">Showroom</option>
//                   <option value="sco(shop-cum-office">SCO(Shop-Cum-Office)</option>
//                   <option value="dss(double-storey-shop)">DSS(Double Storey Shop)</option>
//                   <option value="coomercial-plot">Commercial Plot</option>
//               </select>
//             </div>

//             <div className="form-group">
//               <label>Listing Type</label>
//               <select
//                 value={formData.listingType}
//                 onChange={(e) =>
//                   setFormData({ ...formData, listingType: e.target.value })
//                 }
//               >
//                 <option value="sale">For Sale</option>
//                 <option value="rent">For Rent</option>
//               </select>
//             </div>
//           </div>

//           <div className="grid-2">
//             <div className="form-group">
//               <label>Location</label>
//               <input
//                 value={formData.location}
//                 onChange={(e) =>
//                   setFormData({ ...formData, location: e.target.value })
//                 }
//               />
//             </div>

//             <div className="form-group">
//               <label>Price(In Rupees)</label>
//               <input
//                 value={formData.price}
//                 onChange={(e) =>
//                   setFormData({ ...formData, price: e.target.value })
//                 }
//               />
//             </div>
//           </div>

//           <div className="grid-2">
//             <div className="form-group">
//               <label>Bedrooms</label>
//               <input
//                 value={formData.bedrooms}
//                 onChange={(e) =>
//                   setFormData({ ...formData, bedrooms: e.target.value })
//                 }
//               />
//             </div>

//             <div className="form-group">
//               <label>Washrooms</label>
//               <input
//                 value={formData.washrooms}
//                 onChange={(e) =>
//                   setFormData({ ...formData, washrooms: e.target.value })
//                 }
//               />
//             </div>

            
//           </div>

//           <div className="grid-2">
//   <div className="form-group">
//     <label>Area</label>
//     <input
//       // type="number"
//       placeholder="Enter area"
//       value={formData.area}
//       onChange={(e) =>
//         setFormData({ ...formData, area: e.target.value })
//       }
//     />
//   </div>

//   <div className="form-group">
//     <label>Measurement Type</label>
//     <select
//       value={formData.areaunit}
//       onChange={(e) =>
//         setFormData({ ...formData, areaunit: e.target.value })
//       }
//     >
//       <option value="Sq. Ft.">Square Feet (Sq. Ft.)</option>
//       <option value="Sq. Mtr.">Square Meter (Sq. Mtr.)</option>
//       <option value="Sq. Yd.">Square Yard (Sq. Yd.)</option>
//     </select>
//   </div>
// </div>

//           <div className="form-group">
//             <label>Status</label>
//             <select
//               value={formData.status}
//              onChange={(e) => {
//   const value = e.target.value;
//   setFormData({
//     ...formData,
//     status: value,
//     propertyOtherReason: value === "other" ? formData.propertyOtherReason : ""
//   });
// }}

//             >
//              <option value="all">All Status</option>
//         <option value="available">Available</option>
//         <option value="under_offer">Under Offer</option>
//         <option value="sold">Sold</option>
//         <option value="rented">Rented</option>
//         <option value="unavailable">Unavailable</option>
//         <option value="under_construction">Under Constructor</option>
//         <option value="other">Other</option>
//             </select>

//             {formData.status === "other" && (
//   <div className="form-group">
//     <label>Reason for Other *</label>
//     <input
//       placeholder="Please specify the reason"
//       value={formData.propertyOtherReason}
//       onChange={(e) =>
//         setFormData({
//           ...formData,
//           propertyOtherReason: e.target.value
//         })
//       }
//       required
//     />
//   </div>
// )}

//           </div>

//           <div className="form-group">
//             <label>Description</label>
//             <textarea
//               rows="3"
//               value={formData.description}
//               onChange={(e) =>
//                 setFormData({ ...formData, description: e.target.value })
//               }
//             />
//           </div>

//           {/* AMENITIES */}
//           <div className="form-group">
//             <label>Amenities</label>
//             <div className="inline-input">
//               <input
//                 value={amenityInput}
//                 onChange={(e) => setAmenityInput(e.target.value)}
//                 placeholder="Pool, Gym..."
//               />
//               <button type="button" onClick={addAmenity}>
//                 Add
//               </button>
//             </div>

//             <div className="tag-list">
//               {formData.amenities.map((a, i) => (
//                 <span key={i} className="tag">
//                   {a}
//                   <X size={12} onClick={() => removeAmenity(i)} />
//                 </span>
//               ))}
//             </div>
//           </div>

//       {/* IMAGES */}
// <div className="form-group">
//   <label>Images</label>

//   <input
//     type="file"
//     accept="image/*"
//     multiple
//     onChange={(e) => {
//       const files = Array.from(e.target.files);
//       setFormData({
//         ...formData,
//         images: [...formData.images, ...files]
//       });
//     }}
//   />

//  <div className="image-preview">
//   {formData.images.map((img, i) => (
//     <div key={i} className="image-box">
//       <img
//         src={typeof img === "string" ? img : URL.createObjectURL(img)}
//         alt="preview"
//       />
//       <button type="button" onClick={() => removeImage(i)}>
//         <X size={12} />
//       </button>
//     </div>
//   ))}
// </div>
// </div>


//           {/* FOOTER */}
//           <div className="form-footer">
//             <button type="button" onClick={onCancel} className="btn-outline">
//               Cancel
//             </button>
//             <button type="submit" disabled={isLoading} className="btn-primary">
//               <Save size={16} /> {isLoading ? "Saving..." : "Save Property"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </motion.div>
//   );
// }

// Updated: 02-04-2026
// Changes:
// - Price field: number input + unit dropdown (Thousands / Lakhs / Crores)
// - Image upload restricted to JPG, JPEG, HEIC only
// - New "Property Category" dropdown: Commercial / Residential
// - useEffect syncs price back to value+unit when editing existing property

// Updated: 06-04-2026
// Changes:
// - Price and Amount/Hour inputs now accept decimal values (step="any" added)
// - All dropdowns now have a default disabled "— Select —" placeholder option
// - When listingType === "rent", an "Amount / Hour" field appears
// - API_BASE moved to top of file (was accidentally placed at bottom)

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { X, Save } from "lucide-react";
import "../../css/properties/propertyform.css";

const API_BASE = "https://apicrm.zenrealestate.in";

/* ── Price units ── */
const PRICE_UNITS = [
  { value: "thousands", label: "Thousands", multiplier: 1_000 },
  { value: "lakhs",     label: "Lakhs",     multiplier: 100_000 },
  { value: "crores",    label: "Crores",    multiplier: 10_000_000 },
];

function parsePriceToValueUnit(raw) {
  const num = parseFloat(String(raw).replace(/[^0-9.]/g, ""));
  if (isNaN(num) || num === 0) return { value: "", unit: "lakhs" };
  if (num >= 10_000_000) return { value: String(+(num / 10_000_000).toFixed(4)), unit: "crores" };
  if (num >= 100_000)    return { value: String(+(num / 100_000).toFixed(4)),     unit: "lakhs" };
  return                        { value: String(+(num / 1_000).toFixed(4)),        unit: "thousands" };
}

function computeRawPrice(value, unit) {
  if (!value) return "";
  const multiplier = PRICE_UNITS.find((u) => u.value === unit)?.multiplier || 1;
  return String(parseFloat(value) * multiplier);
}

/* ── Allowed image formats ── */
const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/heic", "image/heif"];
const ALLOWED_EXTENSIONS  = [".jpg", ".jpeg", ".heic", ".heif"];

function isAllowedImage(file) {
  const ext = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
  return ALLOWED_IMAGE_TYPES.includes(file.type.toLowerCase()) || ALLOWED_EXTENSIONS.includes(ext);
}

const EMPTY_FORM = {
  propertyName:        "",
  propertyCategory:    "",
  propertyType:        "",
  listingType:         "",
  location:            "",
  bedrooms:            "",
  washrooms:           "",
  area:                "",
  areaunit:            "",
  status:              "",
  description:         "",
  amenities:           [],
  images:              [],
  ownerName:           "",
  ownerContactNumber:  "",
  propertyOtherReason: "",
  amountPerHour:       "",
};

export default function PropertyForm({ property, onSubmit, onCancel, isLoading }) {
  const [formData,      setFormData]      = useState(EMPTY_FORM);
  const [priceValue,    setPriceValue]    = useState("");
  const [priceUnit,     setPriceUnit]     = useState("lakhs");
  const [amenityInput,  setAmenityInput]  = useState("");
  const [imageError,    setImageError]    = useState("");

  /* Populate when editing */
  useEffect(() => {
    if (property) {
      setFormData({
        propertyName:        property.propertyName        || "",
        propertyCategory:    property.propertyCategory    || "",
        propertyType:        property.propertyType        || "",
        listingType:         property.listingType         || "",
        location:            property.location            || "",
        bedrooms:            property.bedrooms            || "",
        washrooms:           property.washrooms           || "",
        area:                property.area                || "",
        areaunit:            property.areaunit            || "",
        status:              property.status              || "",
        description:         property.description         || "",
        amenities:           property.amenities           || [],
        images:              property.images              || [],
        ownerName:           property.ownerName           || "",
        ownerContactNumber:  property.ownerContactNumber  || "",
        propertyOtherReason: property.propertyOtherReason || "",
        amountPerHour:       property.amountPerHour       || "",
      });
      if (property.price) {
        const p = parsePriceToValueUnit(property.price);
        setPriceValue(p.value);
        setPriceUnit(p.unit);
      }
    }
  }, [property]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.propertyName.trim()) { alert("Property Name is required"); return; }
    if (formData.status === "other" && !formData.propertyOtherReason.trim()) {
      alert("Please specify the reason for 'Other' status"); return;
    }
    if (!priceValue) { alert("Price is required"); return; }
    onSubmit({ ...formData, price: computeRawPrice(priceValue, priceUnit) });
  };

  /* Amenities */
  const addAmenity = () => {
    if (!amenityInput.trim()) return;
    setFormData((prev) => ({ ...prev, amenities: [...prev.amenities, amenityInput.trim()] }));
    setAmenityInput("");
  };
  const removeAmenity = (i) =>
    setFormData((prev) => ({ ...prev, amenities: prev.amenities.filter((_, idx) => idx !== i) }));

  /* Images */
  const handleImageUpload = (e) => {
    const files    = Array.from(e.target.files);
    const rejected = files.filter((f) => !isAllowedImage(f));
    const accepted = files.filter((f) =>  isAllowedImage(f));
    setImageError(rejected.length
      ? `${rejected.map((f) => f.name).join(", ")} — Only JPG, JPEG, and HEIC files are allowed.`
      : "");
    if (accepted.length) setFormData((prev) => ({ ...prev, images: [...prev.images, ...accepted] }));
    e.target.value = "";
  };
  const removeImage = (i) =>
    setFormData((prev) => ({ ...prev, images: prev.images.filter((_, idx) => idx !== i) }));

  /* Price preview */
  const pricePreview = priceValue
    ? `₹ ${new Intl.NumberFormat("en-IN").format(
        parseFloat(priceValue) * (PRICE_UNITS.find((u) => u.value === priceUnit)?.multiplier || 1)
      )}`
    : "";

  const isRent = formData.listingType === "rent";

  return (
    <motion.div
      className="property-form-overlay"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="property-form-card">
        <div className="form-header">
          <h2>{property ? "Edit Property" : "Add New Property"}</h2>
          <button className="icon-btn" type="button" onClick={onCancel}>
            <X size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>

          {/* Property Name */}
          <div className="form-group">
            <label>Property Name *</label>
            <input required name="propertyName" value={formData.propertyName} onChange={handleChange} />
          </div>

          {/* Category + Property Type */}
          <div className="grid-2">
            <div className="form-group">
              <label>Category *</label>
              <select name="propertyCategory" value={formData.propertyCategory} onChange={handleChange}>
                <option value="" disabled>— Select Category —</option>
                <option value="residential">Residential</option>
                <option value="commercial">Commercial</option>
              </select>
            </div>

            <div className="form-group">
              <label>Property Type</label>
              <select name="propertyType" value={formData.propertyType} onChange={handleChange}>
                <option value="" disabled>— Select Type —</option>
                <optgroup label="Residential">
                  <option value="apartment">Apartment / Flat</option>
                  <option value="villa">Villa</option>
                  <option value="residential_plot">Residential Plot / Land</option>
                  <option value="independent_house">Independent House</option>
                  <option value="studio_apartment">Studio Apartment</option>
                  <option value="penthouse">Penthouse</option>
                  <option value="builder_floor">Builder Floor</option>
                </optgroup>
                <optgroup label="Commercial">
                  <option value="office_space">Office Space</option>
                  <option value="commercial_shop">Commercial Shop</option>
                  <option value="showroom">Showroom</option>
                  <option value="sco">SCO (Shop-Cum-Office)</option>
                  <option value="dss">DSS (Double Storey Shop)</option>
                  <option value="commercial_plot">Commercial Plot</option>
                </optgroup>
              </select>
            </div>
          </div>

          {/* Listing Type + Location */}
          <div className="grid-2">
            <div className="form-group">
              <label>Listing Type</label>
              <select
                name="listingType"
                value={formData.listingType}
                onChange={(e) => {
                  const val = e.target.value;
                  setFormData((prev) => ({
                    ...prev,
                    listingType:   val,
                    amountPerHour: val !== "rent" ? "" : prev.amountPerHour,
                  }));
                }}
              >
                <option value="" disabled>— Select Listing Type —</option>
                <option value="sale">For Sale</option>
                <option value="rent">For Rent</option>
              </select>
            </div>

            <div className="form-group">
              <label>Location</label>
              <input name="location" value={formData.location} onChange={handleChange} />
            </div>
          </div>

          {/* Price */}
          <div className="form-group">
            <label>Price *</label>
            <div className="budget-input-group">
              <input
                type="number"
                className="budget-number"
                placeholder="0"
                min="0"
                step="any"
                value={priceValue}
                onChange={(e) => setPriceValue(e.target.value)}
              />
              <select className="budget-unit" value={priceUnit} onChange={(e) => setPriceUnit(e.target.value)}>
                {PRICE_UNITS.map((u) => (
                  <option key={u.value} value={u.value}>{u.label}</option>
                ))}
              </select>
            </div>
            {pricePreview && <span className="budget-preview">{pricePreview}</span>}
          </div>

          {/* Duration (Hours) — visible only when listing type is Rent */}
          {isRent && (
            <div className="form-group">
              <label>Duration (Hours)</label>
              <input
                type="number"
                name="amountPerHour"
                value={formData.amountPerHour}
                onChange={handleChange}
                placeholder="e.g. 1"
                min="0"
                step="any"
              />
            </div>
          )}

          {/* Bedrooms + Washrooms */}
          <div className="grid-2">
            <div className="form-group">
              <label>Bedrooms</label>
              <input name="bedrooms" value={formData.bedrooms} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Washrooms</label>
              <input name="washrooms" value={formData.washrooms} onChange={handleChange} />
            </div>
          </div>

          {/* Area + Measurement */}
          <div className="grid-2">
            <div className="form-group">
              <label>Area</label>
              <input placeholder="Enter area" name="area" value={formData.area} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Measurement Type</label>
              <select name="areaunit" value={formData.areaunit} onChange={handleChange}>
                <option value="" disabled>— Select Unit —</option>
                <option value="Sq. Ft.">Square Feet (Sq. Ft.)</option>
                <option value="Sq. Mtr.">Square Meter (Sq. Mtr.)</option>
                <option value="Sq. Yd.">Square Yard (Sq. Yd.)</option>
              </select>
            </div>
          </div>

          {/* Status */}
          <div className="form-group">
            <label>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={(e) => {
                const value = e.target.value;
                setFormData((prev) => ({
                  ...prev,
                  status: value,
                  propertyOtherReason: value === "other" ? prev.propertyOtherReason : "",
                }));
              }}
            >
              <option value="" disabled>— Select Status —</option>
              <option value="available">Available</option>
              <option value="under_offer">Under Offer</option>
              <option value="sold">Sold</option>
              <option value="rented">Rented</option>
              <option value="unavailable">Unavailable</option>
              <option value="under_construction">Under Construction</option>
              <option value="other">Other</option>
            </select>

            {formData.status === "other" && (
              <div className="form-group" style={{ marginTop: "10px" }}>
                <label>Reason for Other *</label>
                <input
                  placeholder="Please specify the reason"
                  name="propertyOtherReason"
                  value={formData.propertyOtherReason}
                  onChange={handleChange}
                  required
                />
              </div>
            )}
          </div>

          {/* Owner Info */}
          <div className="grid-2">
            <div className="form-group">
              <label>Owner Name</label>
              <input name="ownerName" value={formData.ownerName} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label>Owner Contact</label>
              <input name="ownerContactNumber" value={formData.ownerContactNumber} onChange={handleChange} />
            </div>
          </div>

          {/* Description */}
          <div className="form-group">
            <label>Description</label>
            <textarea rows="3" name="description" value={formData.description} onChange={handleChange} />
          </div>

          {/* Amenities */}
          <div className="form-group">
            <label>Amenities</label>
            <div className="inline-input">
              <input
                value={amenityInput}
                onChange={(e) => setAmenityInput(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addAmenity(); } }}
                placeholder="Pool, Gym, Parking..."
              />
              <button type="button" onClick={addAmenity}>Add</button>
            </div>
            <div className="tag-list">
              {formData.amenities.map((a, i) => (
                <span key={i} className="tag">
                  {a} <X size={12} onClick={() => removeAmenity(i)} />
                </span>
              ))}
            </div>
          </div>

          {/* Images */}
          <div className="form-group">
            <label>Images</label>
            <p className="field-hint">Allowed formats: JPG, JPEG, HEIC</p>
            <input
              type="file"
              accept=".jpg,.jpeg,.heic,.heif,image/jpeg,image/heic,image/heif"
              multiple
              onChange={handleImageUpload}
            />
            {imageError && <p className="field-error">{imageError}</p>}
            <div className="image-preview">
              {formData.images.map((img, i) => (
                <div key={i} className="image-box">
                  <img
                    src={typeof img === "string" ? `${API_BASE}/${img}` : URL.createObjectURL(img)}
                    alt="preview"
                  />
                  <button type="button" onClick={() => removeImage(i)}>
                    <X size={12} />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="form-footer">
            <button type="button" onClick={onCancel} className="btn-outline">Cancel</button>
            <button type="submit" disabled={isLoading} className="btn-primary">
              <Save size={16} /> {isLoading ? "Saving..." : "Save Property"}
            </button>
          </div>

        </form>
      </div>
    </motion.div>
  );
}